var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.203125,
    y: 0.493164,
    width: 68.5548,
    height: 68.5548,
    rx: 9.79354,
    fill: "#DFFFF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6125 16.3809C17.599 16.5082 16.5006 17.007 15.7366 17.6915C15.0733 18.2911 14.5002 19.2143 14.2296 20.127C14.0439 20.7584 13.9908 21.9258 14.1235 22.5784C14.5268 24.5576 15.9647 26.1176 17.8749 26.6482C18.5488 26.8339 19.5676 26.8817 20.2096 26.7543C22.2419 26.3458 23.8231 24.8866 24.3484 22.9286C24.5129 22.329 24.5447 21.2147 24.4227 20.6098C24.1998 19.5168 23.7594 18.6731 22.9953 17.8984C21.8492 16.7417 20.2255 16.1739 18.6125 16.3809ZM21.8439 18.8429C22.0084 18.9278 22.0615 19.018 22.0615 19.2302C22.0615 19.3417 21.8917 19.5433 21.2602 20.1747L20.4537 20.9813L20.5174 21.1511C20.6872 21.6445 20.5121 22.2441 20.0982 22.5943C19.4561 23.1462 18.4321 22.918 18.0766 22.138C17.928 21.8143 17.9439 21.3209 18.1084 20.9972C18.3896 20.44 18.9998 20.1588 19.6047 20.318L19.8806 20.3923L20.6394 19.6282C21.3186 18.9384 21.5096 18.7792 21.6529 18.7686C21.6741 18.7633 21.7643 18.8004 21.8439 18.8429Z",
    fill: "#25AA91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 38.1203V48.584L19.2646 48.5734L20.3365 48.5575L20.3524 38.1044L20.363 27.6513H19.2753H18.1875V38.1203Z",
    fill: "#25AA91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9805 29.8905C26.9593 29.9064 26.9434 34.1248 26.9434 39.2558V48.584H37.7148H48.4862L48.4756 39.2293L48.4597 29.8799H44.4536H40.4474L40.4315 32.8619L40.4209 35.8493H37.7413H35.0617V32.8832C35.0617 30.2301 35.0511 29.917 34.9768 29.8852C34.8654 29.8428 27.023 29.8428 26.9805 29.8905Z",
    fill: "#25AA91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5879 50.4674V51.5552H34.7695H53.9512V50.4674V49.3797H34.7695H15.5879V50.4674Z",
    fill: "#25AA91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9661 53.0251L21.982 53.6512L24.2265 53.6671L26.4657 53.6777V53.041V52.4043H24.2106H21.9502L21.9661 53.0251Z",
    fill: "#25AA91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0732 53.041V53.6777H45.3283H47.5834V53.041V52.4043H45.3283H43.0732V53.041Z",
    fill: "#25AA91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKgGreen);
export default __webpack_public_path__ + "static/media/kg_green.c190f46a919dc522f48f42164c0883fb.svg";
export { ForwardRef as ReactComponent };